import { createAsyncThunk } from "@reduxjs/toolkit";
import proxyApi from "services/apis/proxyApi";

export const fetchDatastreamList = createAsyncThunk(
  "datastream/fetchList",
  async (companyId, thunkAPI) => {
    try {
      const response = await proxyApi.getDataStreamConfig({ companyId });
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Fetch failed");
    }
  }
);
